import { render } from "./ProductsContainer.vue?vue&type=template&id=1b12f5be"
import script from "./ProductsContainer.vue?vue&type=script&lang=js"
export * from "./ProductsContainer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__